import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

export const columns = [
  { name: "usuario", align: "left", sortable: true },
  { name: "nombre", align: "left", sortable: true },
  { name: "email", align: "left", sortable: true },
  { name: "grupo", align: "center", sortable: true },
  { name: "estado", align: "center" },
  { name: "ultimasesion", align: "center" },
  { name: "acciones", align: "center" },
];

export default function buildUsuariosTableData(items = [], map) {
  const rows = (items || []).map((it) => {
    const r = typeof map === "function" ? map(it) : it;

    const estado =
      String(r.status || "").toLowerCase() === "suspendido" || r.disabled
        ? "SUSPENDIDO"
        : "ACTIVO";

    const fecha = r.lastSession ? new Date(r.lastSession) : null;

    return {
      usuario: (
        <SoftTypography variant="button" color="info" fontWeight="bold">
          {r.username || "—"}
        </SoftTypography>
      ),
      nombre: (
        <SoftTypography variant="button" color="text">
          {r.fullName || "—"}
        </SoftTypography>
      ),
      email: (
        <SoftTypography variant="button" color="text">
          {r.email || "—"}
        </SoftTypography>
      ),
      grupo: (
        <SoftTypography variant="button" color="text">
          {r.group ?? "—"}
        </SoftTypography>
      ),
      estado: (
        <SoftTypography
          variant="caption"
          color={estado === "ACTIVO" ? "success" : "error"}
          fontWeight="bold"
        >
          {estado}
        </SoftTypography>
      ),
      ultimasesion: (
        <SoftTypography variant="caption" color="text">
          {fecha ? fecha.toLocaleDateString() : "—"}
        </SoftTypography>
      ),
      acciones: (
        <SoftBox display="flex" justifyContent="center" gap={1}>
          {/* Editar */}
          <IconButton size="small" onClick={r.onEdit} disabled={r.disabledAction} title="Editar">
            <Icon fontSize="small">edit</Icon>
          </IconButton>

          {/* Eliminar */}
          <IconButton
            size="small"
            color="error"
            onClick={r.onDelete}
            disabled={r.disabledAction}
            title="Eliminar"
          >
            <Icon fontSize="small">delete</Icon>
          </IconButton>

          {/* Impersonar (solo si viene handler) */}
          {r.onImpersonate && (
            <IconButton
              size="small"
              color="info"
              onClick={r.onImpersonate}
              disabled={r.disabledAction}
              title="Entrar como este usuario"
            >
              <Icon fontSize="small">login</Icon>
            </IconButton>
          )}
        </SoftBox>
      ),
    };
  });

  return { columns, rows };
}
